import _ from 'lodash';
import { get } from './core/fetch';

export const getSiteTools = async () => {
	const params =
		'tidy=true&treenest=true&dumpproperties=pageRoute,pageurl,jcr:title,redirectTarget,hideInNav&ignoreproperties=sling:resourceType,jcr:created';

	const navUrl = `/secure/adviser/site_tools.nabfeed.content.2.json?${params}`;
	const siteToolsResult = await get(navUrl, { withAuth: true });
	return extractSiteLinks(siteToolsResult);
};

const extractSiteLinks = (data: any = {}) => {
	return _(data.subpages)
		.map(key => {
			return _.flatten(_.toPairs(key))[1];
		})
		.filter((item: any) => !item.hideInNav)
		.map((item: any) => {
			return {
				title: item['jcr:title'],
				pageUrl: item.pageurl,
			};
		})
		.value();
};
